"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProgramCarousel = require("./ProgramCarousel");
Object.keys(_ProgramCarousel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProgramCarousel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProgramCarousel[key];
    }
  });
});